import React from "react";
import { Route, Switch, useRouteMatch } from "react-router";

import Universe from "../Universe";

import "./dashboard.styles.css";

const Dashboard = () => {
  const match = useRouteMatch();
  return (
    <section className="dashboard__wrapper">
      <Switch>
        <Route exact path={`${match.path}`} component={Universe} />
      </Switch>
    </section>
  );
};

export default Dashboard;
